"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.digestTokenAccounts = exports.prepareTokenAccounts = exports.hydrate = exports.preload = exports.findCurrentRate = exports.listCurrentRates = exports.isCompoundDisabled = exports.modes = exports.getSupplyMax = exports.getEnabledAmount = exports.isCompoundTokenSupported = exports.listSupportedCompoundTokens = void 0;
// FIXME there are two tradeoffs and problems to solve
// - first of all, compound api is not that fast and we are not optimized by pulling for each trade
// - secondly, we need to implement the "historical over time" changes.
// IDEA: to me we need to reborn the idea that we will pull daily rates and just stick to it (even if it means some approximation)
var url_1 = __importDefault(require("url"));
var logs_1 = require("@ledgerhq/logs");
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var ethereumjs_abi_1 = __importDefault(require("ethereumjs-abi"));
var values_1 = __importDefault(require("lodash/values"));
var errors_1 = require("@ledgerhq/errors");
var currencies_1 = require("../../../currencies");
var account_1 = require("../../../account");
var network_1 = __importDefault(require("../../../network"));
var promise_1 = require("../../../promise");
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var Ethereum_1 = require("../../../api/Ethereum");
var transaction_1 = require("../transaction");
var env_1 = require("../../../env");
// global state that exists when compound is loaded
var compoundPreloadedValue;
var compoundWhitelist = [
    "ethereum/erc20/compound_dai",
    "ethereum/erc20/compound_usd_coin",
    "ethereum/erc20/compound_usdt",
];
function listSupportedCompoundTokens() {
    return compoundWhitelist.map(currencies_1.getTokenById);
}
exports.listSupportedCompoundTokens = listSupportedCompoundTokens;
function isCompoundTokenSupported(token) {
    return compoundWhitelist.includes(token.id);
}
exports.isCompoundTokenSupported = isCompoundTokenSupported;
function getEnabledAmount(account) {
    var ctoken = (0, currencies_1.findCompoundToken)(account.token);
    var approval = ctoken &&
        (account.approvals || []).find(function (a) { return a.sender.toLowerCase() === ctoken.contractAddress.toLowerCase(); });
    return approval ? new bignumber_js_1.BigNumber(approval.value) : new bignumber_js_1.BigNumber(0);
}
exports.getEnabledAmount = getEnabledAmount;
function getSupplyMax(a) {
    return bignumber_js_1.BigNumber.min(a.spendableBalance, getEnabledAmount(a));
}
exports.getSupplyMax = getSupplyMax;
function contractField(ctoken) {
    var token = (0, currencies_1.getTokenById)(ctoken.compoundFor || "");
    return {
        type: "text",
        label: "Contract",
        value: "Compound " + token.ticker
    };
}
/**
 * "compound.supply" will allocate some compound underlying funds (e.g. DAI) into the compound token (e.g. CDAI)
 * transaction params:
 * - transaction.amount is the supplied amount in underlying unit (e.g. DAI not CDAI). range: ]0, spendableBalance]
 * (NB: transaction.useAllAmount is NOT used. just set amount yourself)
 */
var compoundSupply = {
    fillTransactionStatus: function (a, t, result) {
        var subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        (0, invariant_1["default"])(subAccount, "sub account missing");
        // FIXME: make sure it doesn't break
        if (!subAccount)
            throw new Error("sub account missing");
        if (t.amount.eq(0)) {
            result.errors.amount = new errors_1.AmountRequired();
        }
        else if (t.amount.gt(getSupplyMax(subAccount))) {
            result.errors.amount = new errors_1.NotEnoughBalance();
        }
        result.amount = t.amount;
    },
    fillTransactionData: function (a, t, tx) {
        var subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        (0, invariant_1["default"])(subAccount, "sub account missing");
        // FIXME: make sure it doesn't break
        if (!subAccount)
            throw new Error("sub account missing");
        var cToken = (0, currencies_1.findCompoundToken)(subAccount.token);
        (0, invariant_1["default"])(cToken, "is not a compound supported token");
        if (!cToken)
            throw new Error("is not a compound supported token");
        (0, invariant_1["default"])(t.amount, "amount missing");
        var amount = new bignumber_js_1.BigNumber(t.amount);
        var data = ethereumjs_abi_1["default"].simpleEncode("mint(uint256)", amount.toString(10));
        tx.data = "0x" + data.toString("hex");
        tx.to = cToken.contractAddress;
        tx.value = "0x00";
    },
    fillDeviceTransactionConfig: function (_a, fields) {
        var transaction = _a.transaction, account = _a.account;
        (0, invariant_1["default"])(account.type === "TokenAccount", "token account expected");
        if (account.type !== "TokenAccount") {
            throw new Error("token account expected");
        }
        var ctoken = (0, currencies_1.findCompoundToken)(account.token);
        (0, invariant_1["default"])(ctoken, "is not a compound supported token");
        // FIXME: make sure it doesn't break
        if (!ctoken)
            throw new Error("is not a compound supported token");
        fields.push({
            type: "text",
            label: "Type",
            value: "Lend Assets"
        });
        fields.push({
            type: "text",
            label: "Amount",
            value: (0, currencies_1.formatCurrencyUnit)(account.token.units[0], transaction.amount, {
                showCode: true,
                disableRounding: true
            })
        });
        fields.push(contractField(ctoken));
    },
    fillOptimisticOperation: function (a, t, op) {
        op.type = "FEES";
        var subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        if (subAccount) {
            var currentRate = findCurrentRate(subAccount.token);
            var rate = currentRate ? currentRate.rate : new bignumber_js_1.BigNumber(0);
            var value = new bignumber_js_1.BigNumber(t.amount || 0);
            var compoundValue = value.div(rate).integerValue();
            // ERC20 transfer
            op.subOperations = [
                {
                    id: "".concat(subAccount.id, "-").concat(op.hash, "-SUPPLY"),
                    hash: op.hash,
                    transactionSequenceNumber: op.transactionSequenceNumber,
                    type: "SUPPLY",
                    value: value,
                    fee: op.fee,
                    blockHash: null,
                    blockHeight: null,
                    senders: op.senders,
                    recipients: op.recipients,
                    accountId: subAccount.id,
                    date: new Date(),
                    extra: {
                        compoundValue: compoundValue.toString(10),
                        rate: rate.toString(10)
                    }
                },
            ];
        }
    },
    getResolutionConfig: function () { return ({ erc20: true, externalPlugins: true }); }
};
/**
 * "compound.withdraw" will take back some previously supplied compound tokens back into the underlying asset (e.g. transforming CDAI back into DAI, getting the accumulated profits)
 * transaction params:
 * - transaction.amount in underlying unit (expressed in DAI not CDAI). range: ]0, balance-spendableBalance]
 * - transaction.useAllAmount MUST BE USED in the intend to withdraw all. it will use a different contract method.
 */
var compoundWithdraw = {
    fillTransactionStatus: function (a, t, result) {
        var subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        (0, invariant_1["default"])(subAccount, "sub account missing");
        // FIXME: make sure it doesn't break
        if (!subAccount)
            throw new Error("sub account missing");
        var nonSpendableBalance = subAccount.balance.minus(subAccount.spendableBalance);
        var compoundBalance = subAccount.compoundBalance;
        (0, invariant_1["default"])(compoundBalance, "missing compoundBalance");
        // FIXME: make sure it doesn't break
        if (!compoundBalance)
            throw new Error("missing compoundBalance");
        if (compoundBalance.eq(0) ||
            (!t.useAllAmount && t.amount.gt(nonSpendableBalance))) {
            result.errors.amount = new errors_1.NotEnoughBalance();
        }
        result.amount = t.useAllAmount ? compoundBalance : t.amount;
    },
    fillTransactionData: function (a, t, tx) {
        var _a;
        var subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        (0, invariant_1["default"])(subAccount, "sub account missing");
        // FIXME: make sure it doesn't break
        if (!subAccount)
            throw new Error("sub account missing");
        var cToken = (0, currencies_1.findCompoundToken)(subAccount.token);
        (0, invariant_1["default"])(cToken, "is not a compound supported token");
        // FIXME: make sure it doesn't break
        if (!cToken)
            throw new Error("is not a compound supported token");
        var data = t.useAllAmount
            ? ethereumjs_abi_1["default"].simpleEncode("redeem(uint256)", (_a = subAccount.compoundBalance) === null || _a === void 0 ? void 0 : _a.toString(10))
            : ethereumjs_abi_1["default"].simpleEncode("redeemUnderlying(uint256)", ((0, invariant_1["default"])(t.amount, "amount missing"),
                new bignumber_js_1.BigNumber(t.amount).toString(10)));
        tx.data = "0x" + data.toString("hex");
        tx.value = "0x00";
        tx.to = cToken.contractAddress;
    },
    fillDeviceTransactionConfig: function (_a, fields) {
        var transaction = _a.transaction, account = _a.account;
        (0, invariant_1["default"])(account.type === "TokenAccount", "token account expected");
        // FIXME: make sure it doesn't break
        if (account.type !== "TokenAccount") {
            throw new Error("token account expected");
        }
        var ctoken = (0, currencies_1.findCompoundToken)(account.token);
        (0, invariant_1["default"])(ctoken, "is not a compound supported token");
        // FIXME: make sure it doesn't break
        if (!ctoken)
            throw new Error("is not a compound supported token");
        fields.push({
            type: "text",
            label: "Type",
            value: "Redeem Assets"
        });
        var value = transaction.useAllAmount
            ? (0, currencies_1.formatCurrencyUnit)(ctoken.units[0], account.compoundBalance || new bignumber_js_1.BigNumber(0), {
                showCode: true,
                disableRounding: true
            })
            : (0, currencies_1.formatCurrencyUnit)(account.token.units[0], transaction.amount, {
                showCode: true,
                disableRounding: true
            });
        fields.push({
            type: "text",
            label: "Amount",
            value: value,
            tooltipI18nKey: transaction.useAllAmount
                ? "lend.withdraw.steps.confirmation.tooltip.amountWithdrawn"
                : undefined,
            tooltipI18nArgs: {
                tokenName: ctoken.units[0].code
            }
        });
        fields.push(contractField(ctoken));
    },
    fillOptimisticOperation: function (a, t, op) {
        op.type = "FEES";
        var subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        if (subAccount) {
            var currentRate = findCurrentRate(subAccount.token);
            var value = t.useAllAmount
                ? subAccount.balance.minus(subAccount.spendableBalance)
                : new bignumber_js_1.BigNumber(t.amount || 0);
            var compoundValue = t.useAllAmount
                ? subAccount.compoundBalance || new bignumber_js_1.BigNumber(0)
                : !currentRate
                    ? new bignumber_js_1.BigNumber(0)
                    : value.div(currentRate.rate).integerValue();
            // ERC20 transfer
            op.subOperations = [
                {
                    id: "".concat(subAccount.id, "-").concat(op.hash, "-REDEEM"),
                    hash: op.hash,
                    transactionSequenceNumber: op.transactionSequenceNumber,
                    type: "REDEEM",
                    value: value,
                    fee: op.fee,
                    blockHash: null,
                    blockHeight: null,
                    senders: op.senders,
                    recipients: op.recipients,
                    accountId: subAccount.id,
                    date: new Date(),
                    extra: {
                        compoundValue: compoundValue.toString(10),
                        rate: !currentRate
                            ? new bignumber_js_1.BigNumber(0)
                            : currentRate.rate.toString(10)
                    }
                },
            ];
        }
    }
};
exports.modes = {
    "compound.supply": compoundSupply,
    "compound.withdraw": compoundWithdraw
};
function toCurrentRateRaw(cr) {
    return {
        ctokenId: cr.ctoken.id,
        rate: cr.rate.toString(10),
        supplyAPY: cr.supplyAPY,
        totalSupply: cr.totalSupply.toString(10)
    };
}
function fromCurrentRateRaw(raw) {
    var ctoken = (0, currencies_1.getTokenById)(raw.ctokenId);
    return {
        ctoken: ctoken,
        token: (0, currencies_1.getTokenById)(ctoken.compoundFor || ""),
        rate: new bignumber_js_1.BigNumber(raw.rate),
        supplyAPY: raw.supplyAPY,
        totalSupply: new bignumber_js_1.BigNumber(raw.totalSupply)
    };
}
function isCompoundDisabled() {
    return Boolean(compoundPreloadedValue);
}
exports.isCompoundDisabled = isCompoundDisabled;
function listCurrentRates() {
    return compoundPreloadedValue || [];
}
exports.listCurrentRates = listCurrentRates;
function findCurrentRate(tokenOrCtoken) {
    if (!compoundPreloadedValue)
        return;
    return compoundPreloadedValue.find(function (c) { return c.ctoken === tokenOrCtoken || c.token === tokenOrCtoken; });
}
exports.findCurrentRate = findCurrentRate;
// FIXME: if the current rate is needed at global level, we should consider having it in preload() stuff
// NB we might want to preload at each sync too.
// if that's the case we need to see how to implement this in bridge cycle.
// => allow to define strategy to reload preload()
function preload(currency) {
    return __awaiter(this, void 0, void 0, function () {
        var ctokens, currentRates, preloaded;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (currency.id !== "ethereum") {
                        return [2 /*return*/, Promise.resolve(null)];
                    }
                    ctokens = listSupportedCompoundTokens();
                    return [4 /*yield*/, fetchCurrentRates(ctokens)];
                case 1:
                    currentRates = _a.sent();
                    compoundPreloadedValue = currentRates;
                    preloaded = currentRates ? currentRates.map(toCurrentRateRaw) : null;
                    (0, logs_1.log)("compound", "preloaded data", {
                        preloaded: preloaded
                    });
                    return [2 /*return*/, preloaded];
            }
        });
    });
}
exports.preload = preload;
function hydrate(value, currency) {
    if (currency.id !== "ethereum")
        return;
    compoundPreloadedValue = value ? value.map(fromCurrentRateRaw) : null;
}
exports.hydrate = hydrate;
function prepareTokenAccounts(currency, subAccounts) {
    if (currency.id !== "ethereum")
        return subAccounts;
    if (!compoundPreloadedValue)
        return subAccounts; // noop if compoundPreloadedValue failed to load
    var compoundByTokenId = inferSubAccountsCompound(currency, subAccounts);
    // add implicitly all ctoken account when a token account exists so we can fetch the balance again
    var implicitCTokenAccounts = (0, values_1["default"])(compoundByTokenId)
        .map(function (_a) {
        var tokenAccount = _a.tokenAccount, ctokenAccount = _a.ctokenAccount, ctoken = _a.ctoken;
        return tokenAccount && !ctokenAccount // TODO reuse generateTokenAccount
            ? {
                // this is a placeholder that will be dropped by digestTokenAccounts
                type: "TokenAccount",
                id: "empty_" + ctoken.id,
                token: ctoken,
                parentId: "",
                balance: new bignumber_js_1.BigNumber(0),
                spendableBalance: new bignumber_js_1.BigNumber(0),
                creationDate: new Date(),
                operationsCount: 0,
                operations: [],
                pendingOperations: [],
                starred: false,
                swapHistory: [],
                balanceHistoryCache: account_1.emptyHistoryCache
            }
            : null;
    })
        .filter(Boolean);
    if (implicitCTokenAccounts.length === 0)
        return subAccounts;
    return subAccounts.concat(implicitCTokenAccounts);
}
exports.prepareTokenAccounts = prepareTokenAccounts;
var cdaiToDaiOpMapping = {
    IN: "SUPPLY",
    OUT: "REDEEM"
};
function digestTokenAccounts(currency, subAccounts, address) {
    return __awaiter(this, void 0, void 0, function () {
        var compoundByTokenId, api, approvals, all;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (currency.id !== "ethereum")
                        return [2 /*return*/, subAccounts];
                    if (!compoundPreloadedValue)
                        return [2 /*return*/, subAccounts]; // noop if compoundPreloadedValue failed to load
                    compoundByTokenId = inferSubAccountsCompound(currency, subAccounts);
                    if (Object.keys(compoundByTokenId).length === 0)
                        return [2 /*return*/, subAccounts];
                    api = (0, Ethereum_1.apiForCurrency)(currency);
                    return [4 /*yield*/, (0, promise_1.promiseAllBatched)(3, (0, values_1["default"])(compoundByTokenId), function (_a) {
                            var token = _a.token;
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_b) {
                                    return [2 /*return*/, api
                                            .getERC20ApprovalsPerContract(address, token.contractAddress)
                                            .then(function (approvals) { return ({
                                            approvals: approvals,
                                            token: token
                                        }); })];
                                });
                            });
                        })];
                case 1:
                    approvals = _a.sent();
                    return [4 /*yield*/, (0, promise_1.promiseAllBatched)(2, subAccounts, function (a) { return __awaiter(_this, void 0, void 0, function () {
                            var compoundFor, maybeCompound, ctoken, ctokenAccount, balance, spendableBalance, latestRate, rates_1, newOps, approvalsMatch;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        compoundFor = a.token.compoundFor;
                                        if (compoundFor && isCompoundTokenSupported(a.token)) {
                                            // however, if the related ERC20 account would not exist, we would allow its display
                                            if (!compoundByTokenId[compoundFor]) {
                                                return [2 /*return*/, a];
                                            }
                                            return [2 /*return*/];
                                        }
                                        maybeCompound = compoundByTokenId[a.token.id];
                                        if (!maybeCompound) return [3 /*break*/, 2];
                                        ctoken = maybeCompound.ctoken, ctokenAccount = maybeCompound.ctokenAccount;
                                        if (!ctokenAccount) return [3 /*break*/, 2];
                                        balance = a.balance;
                                        spendableBalance = a.balance;
                                        latestRate = findCurrentRate(ctoken);
                                        if (latestRate) {
                                            balance = balance.plus(ctokenAccount.balance.times(latestRate.rate).integerValue());
                                        }
                                        return [4 /*yield*/, fetchHistoricalRates(ctoken, ctokenAccount.operations.map(function (op) { return op.date; }))];
                                    case 1:
                                        rates_1 = _a.sent();
                                        newOps = ctokenAccount.operations
                                            .map(function (op, i) {
                                            var rate = rates_1[i].rate;
                                            var value = op.value.times(rate).integerValue();
                                            var type = cdaiToDaiOpMapping[op.type];
                                            if (!type)
                                                return;
                                            return __assign(__assign({}, op), { id: "".concat(a.id, "-").concat(op.hash, "-").concat(type), type: type, value: value, accountId: a.id, extra: {
                                                    compoundValue: op.value.toString(10),
                                                    rate: rate.toString(10)
                                                } });
                                        })
                                            .filter(Boolean);
                                        approvalsMatch = approvals.find(function (_a) {
                                            var token = _a.token;
                                            return a.token === token;
                                        });
                                        return [2 /*return*/, __assign(__assign({}, a), { spendableBalance: spendableBalance, compoundBalance: ctokenAccount.balance, balance: balance, operations: (0, jsHelpers_1.mergeOps)(a.operations, newOps), approvals: approvalsMatch ? approvalsMatch.approvals : undefined })];
                                    case 2: return [2 /*return*/, a];
                                }
                            });
                        }); })];
                case 2:
                    all = _a.sent();
                    return [2 /*return*/, all.filter(Boolean)];
            }
        });
    });
}
exports.digestTokenAccounts = digestTokenAccounts;
var fetch = function (path, query) {
    if (query === void 0) { query = {}; }
    return (0, network_1["default"])({
        type: "get",
        url: url_1["default"].format({
            pathname: "".concat((0, env_1.getEnv)("COMPOUND_API"), "/api/v2").concat(path),
            query: query
        })
    });
};
function fetchCurrentRates(tokens) {
    return __awaiter(this, void 0, void 0, function () {
        var r, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (tokens.length === 0)
                        return [2 /*return*/, []];
                    return [4 /*yield*/, fetch("/ctoken", {
                            block_timestamp: 0,
                            addresses: tokens.map(function (c) { return c.contractAddress; }).join(",")
                        })["catch"](function (e) {
                            if ("status" in e) {
                                // if it's an HTTP error, there might be issue with compound API.
                                // we need to be resilent so we turns into degraded mode of our app.
                                return null;
                            }
                            throw e;
                        })];
                case 1:
                    r = _a.sent();
                    if (!r) {
                        return [2 /*return*/, null];
                    }
                    data = r.data;
                    return [2 /*return*/, tokens
                            .map(function (token) {
                            var cToken = data.cToken.find(function (ct) {
                                return ct.token_address.toLowerCase() === token.contractAddress.toLowerCase();
                            });
                            if (!cToken)
                                return;
                            var otoken = (0, currencies_1.getTokenById)(token.compoundFor || "");
                            var rawRate = cToken.exchange_rate.value;
                            var magnitudeRatio = new bignumber_js_1.BigNumber(10).pow(otoken.units[0].magnitude - token.units[0].magnitude);
                            var rate = new bignumber_js_1.BigNumber(rawRate).times(magnitudeRatio);
                            var supplyAPY = new bignumber_js_1.BigNumber(cToken.supply_rate.value)
                                .times(100)
                                .decimalPlaces(2)
                                .toString() + "%";
                            var totalSupply = new bignumber_js_1.BigNumber(cToken.total_supply.value)
                                .times(rawRate)
                                .times(new bignumber_js_1.BigNumber(10).pow(otoken.units[0].magnitude));
                            return {
                                token: otoken,
                                ctoken: token,
                                rate: rate,
                                supplyAPY: supplyAPY,
                                totalSupply: totalSupply
                            };
                        })
                            .filter(Boolean)];
            }
        });
    });
}
function fetchHistoricalRates(token, dates) {
    return __awaiter(this, void 0, void 0, function () {
        var all;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, promise_1.promiseAllBatched)(3, dates, function (date) { return __awaiter(_this, void 0, void 0, function () {
                        var data, cToken, rawRate, otoken, magnitudeRatio, rate;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, fetch("/ctoken", {
                                        block_timestamp: Math.round(date.getTime() / 1000),
                                        addresses: [token.contractAddress]
                                    })];
                                case 1:
                                    data = (_a.sent()).data;
                                    cToken = data.cToken.find(function (ct) {
                                        return ct.token_address.toLowerCase() === token.contractAddress.toLowerCase();
                                    });
                                    if (!cToken)
                                        return [2 /*return*/, {
                                                token: token,
                                                rate: new bignumber_js_1.BigNumber("0")
                                            }];
                                    rawRate = cToken.exchange_rate.value;
                                    otoken = (0, currencies_1.getTokenById)(token.compoundFor || "");
                                    magnitudeRatio = new bignumber_js_1.BigNumber(10).pow(otoken.units[0].magnitude - token.units[0].magnitude);
                                    rate = new bignumber_js_1.BigNumber(rawRate).times(magnitudeRatio);
                                    return [2 /*return*/, {
                                            token: token,
                                            rate: rate
                                        }];
                            }
                        });
                    }); })];
                case 1:
                    all = _a.sent();
                    return [2 /*return*/, all];
            }
        });
    });
}
function inferSubAccountsCompound(currency, subAccounts) {
    var compoundByTokenId = {};
    listSupportedCompoundTokens().forEach(function (ctoken) {
        var compoundFor = ctoken.compoundFor;
        if (compoundFor) {
            var tokenAccount = subAccounts.find(function (a) { return a.token.id === compoundFor; });
            var ctokenAccount = subAccounts.find(function (a) { return a.token === ctoken; });
            if (!tokenAccount && !ctokenAccount)
                return;
            var token = (0, currencies_1.getTokenById)(compoundFor);
            compoundByTokenId[compoundFor] = {
                tokenAccount: tokenAccount,
                token: token,
                ctoken: ctoken,
                ctokenAccount: ctokenAccount
            };
        }
    });
    return compoundByTokenId;
}
//# sourceMappingURL=compound.js.map